import { combineReducers } from 'redux';
import * as actions from './actionTypes'
import { REGISTER_ACTION } from '../loginpages/actionTypes';

// --- Data stores ---

function userTfaDetails(state = {}, action) {
    switch (action.type) {
        case actions.USER_GET_TFA_DETAILS_DATA:
            return action.data;
        default:
            return state;
    }
}

function webAuthnDevices(state = [], action) {
    switch (action.type) {
        case actions.WEBAUTHN_REG_DATA:
            return action.data;
        default:
            return state;
    }
}

function authenticatorDevices(state = [], action) {
    switch (action.type) {
        case actions.AUTHENTICATOR_DEVICES_DATA:
            return action.data;
        default:
            return state;
    }
}

function registerAction(state = '', action) {
    switch (action.type) {
        case REGISTER_ACTION:
            return action.data;
        default:
            return state;
    }
}

// --- Consolidated TFA status (shallow-merge via TFA_UPDATE_STATUS) ---

const INITIAL_TFA_STATUS = {
    webAuthnRegistration: '',
    webAuthnAuth: '',
    pendingWebAuthn: '',
    emailVerified: false,
};

function tfaStatus(state = INITIAL_TFA_STATUS, action) {
    switch (action.type) {
        case actions.TFA_UPDATE_STATUS:
            return { ...state, ...action.data };
        default:
            return state;
    }
}

// --- Error state ---

function tfaError(state = null, action) {
    switch (action.type) {
        case actions.TFA_SET_ERROR:
            return action.data;
        case actions.TFA_CLEAR_ERROR:
            return null;
        default:
            return state;
    }
}

export default combineReducers({
    userTfaDetails,
    webAuthnDevices,
    authenticatorDevices,
    registerAction,
    tfaStatus,
    tfaError,
});
